import React, { useState } from "react";
import TitleDescription from "../../../components/newMotorPolicy/titleDescription/titleDescription";
import FileClaimMotorLayout from "./fileClaimMotorLayout";
import useFileClaimFlow from "../../../hooks/useFileClaimFlow";
import MotorPolicyOptionsCard from "../../../components/motorPolicyOptionsCard/motorPolicyOptionsCard";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import { PROPERTY_DAMAGE } from "./NonSolidarityUser/data";
import { useTranslation } from "react-i18next";
import { FILE_CLAIM_PROPERTY_DAMAGE_FLOW } from "./data";
import ClaimDisclaimer from "./claimDisclaimer";

let cashOption = {
  key: "cash",
  title_en: "Receive Cash",
  title_ar: "تلقي النقود",
  description_en: "I want to receive cash and I will repair my vehicle",
  description_ar: "أريد الحصول على نقود وسأصلح سيارتي",
};
const planOptions = [
  {
    key: "repair",
    title_en: "Repair my vehicle",
    title_ar: "إصلاح سيارتي",
    description_en: "I want Solidarity to repair my vehicle",
    description_ar: "أريد أن تقوم سوليدرتي بإصلاح سيارتي",
  },
  cashOption,
];

const propertyDamagePlanOptions = [
  {
    key: "repair",
    title_en: "Repair my property",
    title_ar: "إصلاح ممتلكاتي",
    description_en: "I want Solidarity to repair my property",
    description_ar: "أريد أن تقوم سوليدرتي بإصلاح ممتلكاتي",
  },
  {
    key: "cash",
    title_en: "Receive Cash",
    title_ar: "تلقي النقود",
    description_en: "I want to receive cash and I will repair my property",
    description_ar: "أريد الحصول على نقود وسأصلح ممتلكاتي",
  }
];

function RepairOrCashPage({
  selectedOption,
  setSelectedOption,
  selectedInsuredType,
}) {
  const { t } = useTranslation();

  //const [selectedOption, setSelectedOption] = useState(null);
  const translate = useLanguageTranslate();
  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };
  const { handleNextSubstep, flowType } = useFileClaimFlow();
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [isDealerConsented, setIsDealerConsented] = useState(false);

  const isPropertyDamage =
    selectedInsuredType == PROPERTY_DAMAGE ||
    flowType == FILE_CLAIM_PROPERTY_DAMAGE_FLOW;
  const showAcknowledgement = !isPropertyDamage;
  // Dealer-workshop cost consent. The garage list doesn't say which garages
  // are authorized dealers yet, so it is asked on every vehicle repair claim.
  const showDealerConsent = showAcknowledgement && selectedOption === "repair";
  const dealerConsentItems = t(
    "motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.dealer_consent_items",
    { returnObjects: true }
  );

  const continueClickHanlder = () => {
    handleNextSubstep();
  };
  return (
    <FileClaimMotorLayout
      btn_disabled={
        !selectedOption ||
        (showAcknowledgement && !isAcknowledged) ||
        (showDealerConsent && !isDealerConsented)
      }
      btn_onClick={continueClickHanlder}
    >
      <div className="mx-auto bg-white max767:p-5 w-[500px] max-w-[100%]">
        <div className="max767:hidden">
          <TitleDescription
            title={t(
              "motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.title"
            )}
            description={t(
              "motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.description"
            )}
          />
        </div>
        <div className="max767:block hidden max767:mb-6">
          <TitleDescription
            title={t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.mobile_title")}
            description={t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.description")}
          />
        </div>
        <div>
          {(isPropertyDamage ? propertyDamagePlanOptions : planOptions).map(
            (plan) => (
              <MotorPolicyOptionsCard
                key={plan.key}
                title={translate(plan.title_en, plan.title_ar)}
                description={translate(
                  plan.description_en,
                  plan.description_ar
                )}
                isSelected={selectedOption == plan.key}
                onSelect={() => handleOptionSelect(plan.key)}
              />
            )
          )}
        </div>
        {showAcknowledgement && (
          <ClaimDisclaimer
            title={t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.acknowledgement_title")}
            checked={isAcknowledged}
            onCheckedChange={setIsAcknowledged}
          >
            <p>{t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.acknowledgement_para1")}</p>
            <p>
              {t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.acknowledgement_para2_prefix")}
              <strong className="font-semibold text-[#1A2024]">
                {t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.acknowledgement_para2_bold")}
              </strong>
              {t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.acknowledgement_para2_suffix")}
            </p>
            <p>{t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.acknowledgement_para3")}</p>
          </ClaimDisclaimer>
        )}
        {showDealerConsent && (
          <ClaimDisclaimer
            title={t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.dealer_consent_title")}
            checked={isDealerConsented}
            onCheckedChange={setIsDealerConsented}
          >
            <p>{t("motorInsurance.fileAClaimFlow.soilidarityUserRepairOrCashPage.dealer_consent_intro")}</p>
            <ol className="list-decimal ps-4 space-y-1">
              {(Array.isArray(dealerConsentItems) ? dealerConsentItems : []).map(
                (item) => (
                  <li key={item}>{item}</li>
                )
              )}
            </ol>
          </ClaimDisclaimer>
        )}
      </div>
    </FileClaimMotorLayout>
  );
}

export default RepairOrCashPage;
